import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export function useMyConnectorGrants({ enabled = true } = {}) {
  const [user, userResult] = useQuery(queries.currentUser());
  return useQuery(queries.myConnectorGrants({ email: user?.email }), {
    enabled: enabled && userResult.type === "complete",
  });
}
